export const blockIconsPhotoandimageSlideshowNew = (
	<span className='material-symbols-outlined'>slideshow</span>
);
